import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Breadcrums from "../../../common/breadcrumbs";
import Loader from "../../../common/loader";
import { capitalizeFirstLetter, formateDate } from "../../../../../utils/commonfunction";
import * as postsServices from "../../../services/posts.services.js";
import { useTranslation } from "react-i18next";

const PostView = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const params = useParams();
  const [showdefault, setShowDefault] = useState({});
  const breadcrumbs = [
    { title: t("link_dashboard"), url: "/admin/dashboard" },
    { title: t("Posts"), url: "/admin/posts/list/1" },
    { title: t("link_view"), url: "" },
  ];

  useEffect(() => {
    postsServices
      .Details(params.id)
      .then((data) => {
        setShowDefault(data && data.data ? data.data : {});
      })
      .catch((error) => {
        console.log("error=====>", error);
      });
  }, [params.id]);

  const renderPostImages = () => {
    const images = showdefault?.images || [];
    if (!Array.isArray(images) || images.length === 0) {
      return "N/A";
    }

    return (
      <div className="d-flex flex-wrap gap-2">
        {images.map((img, index) => {
          const src = typeof img === "string" ? img : img.url;
          if (!src) return null;
          return (
            <img
              key={index}
              src={src}
              alt="post"
              style={{
                width: "100px",
                height: "100px",
                objectFit: "cover",
                borderRadius: "6px",
                border: "1px solid #ddd",
                marginRight: "8px",
                marginBottom: "8px",
              }}
            />
          );
        })}
      </div>
    );
  };

  return (
    <>
      <Breadcrums data={breadcrumbs} />
      <div className="row row-sm">
        <div className="col-lg-12 col-md-12 animation_fade">
          <div className="card custom-card">
            <div className="card-body">
              <div>
                <h6 className="main-content-label mb-3">{t("Post Details")}</h6>
              </div>
              {showdefault && Object.keys(showdefault)?.length > 0 ? (
                <div className="row">
                  <div className="col-lg-12 form-group">
                    <table id="simple-table" className="table table-bordered table-hover">
                      <tbody>
                        <tr>
                          <th>{t("Caption")}</th>
                          <td style={{ wordBreak: "break-word" }}>
                            {showdefault?.caption ? capitalizeFirstLetter(showdefault.caption) : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("Created By")}</th>
                          <td>
                            {showdefault?.createdBy
                              ? `${showdefault.createdBy.first_name || ""} ${showdefault.createdBy.last_name || ""}`
                              : "N/A"}
                          </td>
                        </tr>
                        <tr>
                          <th>{t("Email")}</th>
                          <td>{showdefault?.createdBy?.email || "N/A"}</td>
                        </tr>
                        <tr>
                          <th>{t("Images")}</th>
                          <td>{renderPostImages()}</td>
                        </tr>
                        <tr>
                          <th>{t("Likes")}</th>
                          <td>{showdefault?.likesCount || 0}</td>
                        </tr>
                        <tr>
                          <th>{t("Comments")}</th>
                          <td>{showdefault?.commentsCount || 0}</td>
                        </tr>
                        <tr>
                          <th>{t("list_heading_created_date")}</th>
                          <td>{showdefault?.createdAt ? formateDate(showdefault.createdAt) : "N/A"}</td>
                        </tr>
                      </tbody>
                    </table>
                    <div className="mt-5">
                      <button className="btn ripple btn-dark" type="button" onClick={() => navigate(-1)}>
                        <i className="ace-icon-solid ion-arrow-return-left bigger-110 mx-1"></i>
                        {t("btn_back")}
                      </button>
                    </div>
                  </div>
                </div>
              ) : (
                <Loader />
              )}
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default PostView;
